function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4 5.50012H5V11.5001H4V5.50012Z",
  fill: "#888888"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7 5.50012H8V11.5001H7V5.50012Z",
  fill: "#888888"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M0 2.50012V3.50012H1V13.5001C1 13.7653 1.10536 14.0197 1.29289 14.2072C1.48043 14.3948 1.73478 14.5001 2 14.5001H10C10.2652 14.5001 10.5196 14.3948 10.7071 14.2072C10.8946 14.0197 11 13.7653 11 13.5001V3.50012H12V2.50012H0ZM2 13.5001V3.50012H10V13.5001H2Z",
  fill: "#888888"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M4 0.500122H8V1.50012H4V0.500122Z",
  fill: "#888888"
});

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.438a9d77.svg";
export { ForwardRef as ReactComponent };